import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { humanize } from 'underscore.string';
import _ from 'underscore';
import { withTranslation } from 'react-i18next';
import SearchBox from 'components/site/SearchBox';
import Badge from '../ui/Badge';
import { searchOrdersByOrderId } from '../../utils/OrderWebAPIUtils';
function onSelect(_value, item, history) {
    if (item && item._id) {
        history.push(`/orders/${item._id}`, { id: item._id });
    }
}
class OrderSearch extends Component {
    constructor(props) {
        super(props);
        this.handleSearch = (input) => {
            const order_id = input.trim().toUpperCase();
            this.search(order_id);
        };
        this.state = {
            items: [],
        };
        this.handleSearch = _.debounce(this.handleSearch, 500);
    }
    clear() {
        this.setState({ items: [] });
    }
    async search(orderId) {
        const pattern = /^(\d+)$/i;
        let searchTerm;
        const matches = orderId.match(pattern);
        if (matches) {
            searchTerm = `ORD-${matches[0]}`;
        }
        else {
            searchTerm = orderId;
        }
        try {
            const { entity: { items }, } = await searchOrdersByOrderId(searchTerm, {
                page: 1,
                per_page: 10,
                paginate: false,
                lean: true,
            });
            this.setState({ items });
        }
        catch (e) {
            console.error(e);
        }
    }
    renderItem(item) {
        const display = item.order_id;
        return (React.createElement("div", { key: item._id, id: item._id, className: "list-group-item", style: { cursor: 'pointer' } },
            React.createElement("h4", { className: "flex" },
                React.createElement("span", { className: "mr-2" }, display),
                React.createElement(Badge, { type: "green", text: humanize(item.status) }))));
    }
    render() {
        const onSelection = this.props.onSelect || onSelect;
        const { t } = this.props;
        return (React.createElement(SearchBox, { items: this.state.items, clear: () => this.clear(), search: this.handleSearch, placeholder: t('SEARCH_FOR_REFERENCE'), onSelect: (value, item) => onSelection(value, item, this.props.history), renderItem: (item) => this.renderItem(item), nGramLength: 3 }));
    }
}
OrderSearch.propTypes = {
    onSelect: PropTypes.func,
};
OrderSearch.propTypes = {
    history: PropTypes.object.isRequired,
    onSelect: PropTypes.func.isRequired,
};
export default withRouter(withTranslation()(OrderSearch));
